module.exports = __webpack_public_path__ + "img/crvena-zvezda-logo-icon.94b60f9d.png";